var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08_\u5220\u9664") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.07,31.33a2,2,0,0,0-2,2v6a2,2,0,0,0,4,0v-6A2,2,0,0,0,50.07,31.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.07,22.07v24.1a2,2,0,0,0,4,0V22.07a2,2,0,0,0-4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.07,22.07v24.1a2,2,0,0,0,4,0V22.07a2,2,0,0,0-4,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54,8H34V6a2,2,0,1,0-4,0V8H10a2,2,0,1,0,0,4h2.06a3.68,3.68,0,0,0-.06.58V55.43A4.37,4.37,0,0,0,16.14,60H47.89A4.37,4.37,0,0,0,52,55.43V46.85a2,2,0,0,0-4,0v8.58c0,.35-.16.56-.12.57L16.23,56a.74.74,0,0,1-.22-.59V12.58a2.28,2.28,0,0,1,.13-.58H47.81a.78.78,0,0,1,.2.58V24.86a2,2,0,1,0,4,0V12.58A5.44,5.44,0,0,0,52,12h2a2,2,0,0,0,0-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.355bc24b.svg";
export { ForwardRef as ReactComponent };